module.exports = __webpack_public_path__ + "img/pvc_expodots_0010_white.81d5721a.jpg";